<template>
  <div class="h-full">
    <DataGetter
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData
        }
      "
      @dataIsEmpty="platformAccessSubscription = null"
      contentId="platformAccessSubscription"
    />
    <!-- <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData
        }
      "
      @dataIsEmpty="subscription = null"
      contentId="subscription"
    /> -->
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
      @dataIsEmpty="userData = null"
    />
    <RoundFilterUtils />
    <Svgs />
    <SplashComponent class="absolute w-full h-full z-[2]" v-if="!hideSplash" />
    <div
      v-if="canGoIntoApp"
      class="w-full h-full duration-300"
      :class="{ 'opacity-0': !hideSplash }"
    >
      <div class="h-full w-full">
        <div class="flex w-full h-full">
          <MenuPannel :needPlatformAccessPayment="needPlatformAccessPayment" />
          <!-- df            {{platformAccessSubscription}}dd -->
          <!-- <div class="w-full h-full flex flex-col"> -->
            <div
            class="w-full h-full flex flex-col"
            v-if="!needPlatformAccessPayment"
            >
            <PlatformAccessTopSection v-if="needPlatformAccessPayment" />
            <UserValidationTopSection v-else />
            <router-view />
          </div>
          <div class="w-full h-full" v-if="needPlatformAccessPayment">
            <PlatformAccessSubscription />
          </div>
        </div>
      </div>
      <div :key="pageContentKey">
        <OrderDetailsDialog />
        <PaymentDetailsDialog />
        <TourGuide />
        <PromptModal />
        <LinkOpener />
        <ChoiceModal />
        <LoadingPromptModal />
        <PasswordReset />
        <LocationSelectorDialog />
      </div>
    </div>
    <ToastNotification />
  </div>
</template>

<script>
import LinkOpener from './components/appComponent/LinkOpener.vue'
import MenuPannel from './components/appComponent/MenuPannel.vue'
import SplashComponent from './components/appComponent/SplashComponent.vue'
import TourGuide from './components/appComponent/TourGuide.vue'
import ChoiceModal from './components/utils/ChoiceModal.vue'
import DataGetter from './components/utils/DataGetter.vue'
import LoadingPromptModal from './components/utils/LoadingPromptModal.vue'
import PromptModal from './components/utils/PromptModal.vue'
import ToastNotification from './components/utils/ToastNotification.vue'
import RoundFilterUtils from './components/utils/RoundFilterUtils.vue'
import Svgs from './components/utils/Svgs.vue'
import LocationSelectorDialog from './components/location/LocationSelectorDialog.vue'
import UserValidationTopSection from './components/userValidation/UserValidationTopSection.vue'
import PaymentDetailsDialog from './components/payments/PaymentDetailsDialog.vue'
import OrderDetailsDialog from './components/order/OrderDetailsDialog.vue'
import UserProperty from './components/user/UserProperty.vue'
import PlatformAccessSubscription from './components/platformAccess/PlatformAccessSubscription.vue'
import PlatformAccessTopSection from './components/platformAccess/PlatformAccessTopSection.vue'
import PasswordReset from './components/appComponent/PasswordReset.vue'

export default {
  name: 'App',
  metaInfo: {
    link: [],
  },
  components: {
    PasswordReset,
    DataGetter,
    PromptModal,
    ToastNotification,
    SplashComponent,
    LoadingPromptModal,
    ChoiceModal,
    LinkOpener,
    TourGuide,
    RoundFilterUtils,
    Svgs,
    LocationSelectorDialog,
    MenuPannel,
    UserValidationTopSection,
    PaymentDetailsDialog,
    OrderDetailsDialog,
    UserProperty,
    PlatformAccessSubscription,
    PlatformAccessTopSection,
  },
  data() {
    return {
      platformAccessSubscription: null,
      subscription: null,
      userData: null,
      pageContentKey: 'initial',
      appInitialized: false,
      hideSplash: false,
      pages: [
        {
          path: '/home',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/orders',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/products',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/promotion',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/chargebacks',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/payments',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/customers',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/riders',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/deliveryLocations',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/deals',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/withdrawal',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/transfer',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/chat',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/preferences',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/pro',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/validation',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/acceptnotification',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/login',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/register',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
        {
          path: '/welcome',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
          // bottomNavColor: {
          //   '': '#ffffff',
          //   '#bottomsheet': '#B2B2B2',
          //   '#modalvisible': '#B2B2B2',
          //   '#tourguide': '#B2B2B2',
          //   '#chat': '#ffffff',
          // },
        },
        {
          path: '/updateavailable',
          requirements: ['appNotUpToDate'],
          redirectTo: ['/home'],
          themeColor: {
            '': '#ffffff',
            '#bottomsheet': '#B2B2B2',
            '#modalvisible': '#B2B2B2',
            '#tourguide': '#B2B2B2',
            '#chat': '#ffffff',
          },
        },
      ],
      userTheme: 'light',
    }
  },
  beforeMount() {
    // this.$router.push({ path: "/", replace: true }).catch(() => {});
  },
  async mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    await this.initializeApp()
    this.initListeners()
    this.loadLottiePlayer()
    this.tryEnableLogs()
  },
  beforeUnmount() {},
  unmounted() {},
  methods: {
    tryEnableLogs() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      if (this.$router?.query?.enableLogs) window.console = window.realConsole
    },
    async initializeApp() {
      this.saveRefererCode()
      // await this.$router.push('/').catch(e => {})
      // await this.$router.push('/#initiating').catch(e => {})
      const userConnected = this.$QuickStorage.getStored('user_connected')
      if (userConnected) this.listenWorkerInitiated()
      await new Promise(r => setTimeout(r, 500))
      await this.handleRoute()
      setTimeout(() => {
        this.appInitialized = true
        this.handleRoute()
      }, 500)
    },
    saveRefererCode() {
      const refererCode = this.$route.query?.ref
      if (!refererCode) return
      this.$QuickStorage.storeData('refererCode', refererCode)
    },
    async handleRoute(newRoute = this.$route) {
      let page = this.pages.find(page => page.path == newRoute.path)
      if (!page) page = this.pages[0]

      this.resetThemeColor(page)
      let requirementNotMetIndex = -1
      await Promise.all(
        page.requirements.map(async (requirement, index) => {
          if (requirementNotMetIndex !== -1) return
          if (await this.requirementMet(requirement)) return
          requirementNotMetIndex = index
          return
        }),
      )
      const redirection = page.redirectTo[requirementNotMetIndex]
      if (redirection) {
        await this.$router.push(redirection).catch(e => {})
      } else if (page.path !== newRoute.path) {
        await this.$router.push(page.path).catch(e => {})
      }
    },
    async requirementMet(requirement) {
      if (requirement == 'userConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return userConnected
      } else if (requirement == 'userNotConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return !userConnected
      } else if (requirement == 'appUpToDate') {
        return await this.appIsUpToDate()
      } else if (requirement == 'appNotUpToDate') {
        return !(await this.appIsUpToDate())
      }
    },
    async appIsUpToDate() {
      const appVersionData =
        await this.$Events.sendDataRequestResolve('appVersionData')
      if (!appVersionData?.metaData?.appLastVersion) return true
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const onlineVersion = parseInt(
        `${appVersionData.metaData?.appLastVersion}`,
      )
      const currentVersion = parseInt(`${userPreferences?.appVersion}`)

      return currentVersion >= onlineVersion
    },
    listenWorkerInitiated() {
      const reloadingPageTimeoutId = setTimeout(() => {
        window.location.reload()
      }, 10000)
      const pingInterval = setInterval(() => {
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadingPageTimeoutId)
          clearInterval(pingInterval)
          this.checkUserConnectionData()
        })
      }, 1000)
    },

    async checkUserConnectionData() {
      const userData = await this.$Events.sendDataRequestResolve('userData')
      if (!userData?.email) {
        this.$Events.dispatchEvent('logout_requested')
      }
      // this.displayedProject = this.$Controller.getDisplayedProject();
    },
    initListeners() {
      this.$Events.handleEvent('login_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('registration_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('logout_requested', () => {
        this.$router.push('/login')
        this.$Events.dispatchEvent('clean_all_data_requested')
      })
      this.$Events.handleEvent('logout_done', () => {
        this.$router.push('/login')
      })
      this.$Events.handleEvent(
        'ask_notification_permission_to_user_required',
        () => {
          this.$router.push('/acceptnotification')
        },
      )
      this.$Events.handleEvent('single_transaction_updated', transaction => {
        if (transaction?.status !== 'pending') return
        const paymentUrl = transaction?.paymentUrl
        if (!paymentUrl) return
        if (!window.openedUrls) window.openedUrls = []
        if (window.openedUrls.includes(paymentUrl)) return
        window.open(paymentUrl, '_blank')
        window.openedUrls.push(paymentUrl)
      })
      this.$Events.handleEvent('notification_action_click', notifData => {
        const { data, actionButtonIndex } = notifData
        const matchingAction = (data.actions || [])[actionButtonIndex || 0]
        if (matchingAction.url) {
          window.open(matchingAction.url, '_blank')
        }
        if (matchingAction.recharge1xBet) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: '1xbet',
          })
        }
        if (matchingAction.rechargeBetwinner) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: 'betwinner',
          })
        }
        if (matchingAction.matchList) {
          this.$Events.dispatchEvent('show_match_list', data.matches)
        }
      })
      this.$Events.handleEvent('deposit_action_requested', () => {
        document.querySelector('#home_navigation_mainHome').click()
        setTimeout(() => {
          this.$Events.dispatchEvent('required_tour_guide', { id: 'service' })
        }, 800)
      })
      this.$Events.handleEvent(
        'vip_subscription_section_display_required',
        () => {
          document.querySelector('#home_navigation_coupons').click()
          setTimeout(() => {
            document.querySelector('#tab_vip').click()
          }, 1000)
        },
      )
      this.$Events.handleEvent('lang_changed', () => {
        // this.key = Date.now();
        this.$forceUpdate()
      })
      this.$Events.handleEvent('color_theme_changed', () => {
        this.key = Date.now()
        // this.$forceUpdate();
      })
      this.$Events.handleEvent('user_not_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: "Nous n'arrivons pas à mettre à jour les infos de votre compte. Veuillez réessayer",
          type: 'warning',
          title: 'Echec',
        })
      })
      this.$Events.handleEvent('user_data_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: 'Les infos de votre compte ont été mises à jour correctement',
          type: 'success',
        })
      })
    },
    loadLottiePlayer() {
      const scriptSelector = 'script[name="lottieScript"]'
      const lottieScriptAlreadyAdded = document.querySelector(scriptSelector)
      if (lottieScriptAlreadyAdded) return
      const lottieScript = document.createElement('script')
      lottieScript.setAttribute('name', 'lottieScript')
      lottieScript.setAttribute('src', '/plugins/lottie-player.js')
      document.head.appendChild(lottieScript)
    },
    resetThemeColor(pageData) {
      if (!this.appInitialized) return
      const hash = this.$route.hash || ''

      let themeColor = pageData.themeColor['']
      Object.keys(pageData.themeColor).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        themeColor = pageData.themeColor[pageHash]
      })
      if (themeColor) {
        this.$Commons.setThemeColor(themeColor)
      }

      let bottomNavColor
      if (pageData.bottomNavColor) pageData.bottomNavColor['']
      Object.keys(pageData.bottomNavColor || {}).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        bottomNavColor = pageData.bottomNavColor[pageHash]
      })
      if (bottomNavColor) {
        document.body.style.backgroundColor = bottomNavColor
      } else {
        document.body.style.removeProperty('background-color')
      }
    },
  },

  computed: {
    canGoIntoApp() {
      return this.appInitialized
    },
    needPlatformAccessPayment() {
      if (!this.userData) return false
      if (!this.platformAccessSubscription) return false
      // if (!this.subscription) return false
      return !this.platformAccessSubscription
        .isActive /* && !this.subscription.isActive */
    },
  },
  watch: {
    $route: {
      deep: true,
      async handler(newValue) {
        this.handleRoute(newValue)
      },
    },
    canGoIntoApp() {
      this.$Events.dispatchEvent('app_initialized')
      // setTimeout(() => {
      this.hideSplash = true
      // }, 1500)
    },
  },
}
</script>
